export default "__VITE_ASSET__BwOq3hri__"